export const ADMISSION_EXPIRED_SESSION_ROUTE = "/admission/session-expired";
